import { render, staticRenderFns } from "./load-more.vue?vue&type=template&id=4c1a90a1&scoped=true&"
import script from "./load-more.vue?vue&type=script&lang=js&"
export * from "./load-more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a90a1",
  null
  
)

export default component.exports